var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('PageHeader',{attrs:{"image":_vm.PerguntasFrequentesBannerImage,"ariaLabel":"Pessoas correndo","minHeight":421,"title":"Dúvidas","text":"Consulte nossas perguntas frequentes."}})}
var staticRenderFns = []

export { render, staticRenderFns }